module.exports = __webpack_public_path__ + "img/14.ac47247.jpg";